import { AppState } from '../types/store';

export const getStaffByPosition = (state: AppState) => state?.staffByPosition;
